import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { RetornoSelecao } from '../../../../shared/gridview/RetornoSelecao';
import { ConversaoLibraConverte } from '../../../../shared/conversao-libra/conversao-libra-converte';
import { FiltroDealers } from '../filtro-dealer';
import { FiltroMarcas } from '../filtro-marcas';
import { FiltroTipoOs } from '../filtro-tipo-os';
import { RmpvDetalhadoFiltroService } from '../rmpv-detalhado-filtro.service';
import { RmpvDetalhadoService } from '../rmpv-detalhado.service';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RmpvDetalhadoLista } from './rmpv-detalhado-lista';
import { Paginator } from 'primeng/paginator';
import * as XLSX from 'xlsx';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../../../shared/utils/utils';

@Component({
  selector: 'app-rmpv-detalhado-lista',
  templateUrl: './rmpv-detalhado-lista.component.html',
  styleUrls: ['./rmpv-detalhado-lista.component.css']
})


export class RmpvDetalhadoListaComponent implements OnInit, OnDestroy {
  @Input() filtros: any;
  filtroRecebido: any;
  form: FormGroup;
  subscription: any;
  idOs: any;
  temAcompanhamentoOs = false;

  selecionado: object;
  selecionados = [];
  gruposEconomicos = [];
  status = [];
  entregue = [];
  blindado = [];
  andamentosOpcoes: { label: string; value: string }[] = [];
  totais: any = {};
  _selectedColumns: any[];

  columns: any;
  columnsGeral: RmpvDetalhadoLista[];
  columnsResumida: RmpvDetalhadoLista[];

  first = 0;
  displayRows: number = 0;
  rows = 10;
  totalRecords = 0;

  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosMarcas: boolean = false;
  displayFiltrosOS: boolean = false;
  displayFiltrosDealers: boolean = false;
  filtrado: boolean = false;

  nomeModulo: string;

  filtrosMarcas: FiltroMarcas;
  filtrosTipoOs: FiltroTipoOs;
  filtrosDealers: FiltroDealers;

  retorno: any[];
  registros: any[] = [];
  configShowNumber = {
    animation: 'count',
    format: '(,ddd).dd'
  };
  dataInicial: Date;
  dataFinal: Date;

  dataFim: any;
  dataInc: any;

  dataEntrega: string;
  cargaTela: boolean;
  detalheGrid: any;
  countFaturamentoServicPeca: any;
  buscaResumida: any;
  buscaAnalitica: any;
  dataInicio: any;
  
  idDealer: any;
  chassi: any;
  numeroOS: any;
  paginaAtual: any;
  quantidadeRegistrosPorPagina: any;
  chassiRecebe: string;
  valoreRecebe: any;
  @ViewChild('dt') dt: Table;
  @ViewChild('pg') paginator: Paginator;

  private listagemSub: Subscription;

  dadosTranslate = {
    "O.S.": "rmpv.detalhado.gridHeader.os",
    "Cliente": "rmpv.detalhado.gridHeader.cliente",
    "Modelo": "rmpv.detalhado.gridHeader.modelo",
    "Chassi": "rmpv.detalhado.gridHeader.chassi",
    "Valor Serviço": "rmpv.detalhado.gridHeader.valorServico",
    "Valor Peça": "rmpv.detalhado.gridHeader.valorPeca",
    "Horas Vendidas": "rmpv.detalhado.gridHeader.horasVendidas",
    "Devolução": "rmpv.detalhado.gridHeader.devolucao",
    "Faturamento": "rmpv.detalhado.gridHeader.faturamento",
    "Status": "rmpv.detalhado.gridHeader.status",
    "Data Entrega": "rmpv.detalhado.gridHeader.dataEntrega",
    "Tipo O.S.": "rmpv.detalhado.gridHeader.tipoOS",
    "Data de Último Apontamento": "rmpv.detalhado.gridHeader.dataFimServico",
    "Andamento": "rmpv.detalhado.gridHeader.andamento",
    "KM": "rmpv.detalhado.gridHeader.kmAtual",
    "Data de Fechamento": "rmpv.detalhado.gridHeader.dataEncerramento",
    "Data de Liberação": "rmpv.detalhado.gridHeader.dataLiberacao",
    "Os Complementar": "rmpv.detalhado.gridHeader.complemento",
    "Classificação Serviço": "rmpv.detalhado.gridHeader.tipoServico",
    "Id número O.S.": "rmpv.detalhado.gridHeader.idNumeroOs",
    "Número Prefeitura": "rmpv.detalhado.gridHeader.numeroPrefeitura",
    "Data NF Peça": "rmpv.detalhado.gridHeader.dataNfPeca",
    "Data NF Mão de Obra": "rmpv.detalhado.gridHeader.dataNfMaoDeObra",
    "Data Agendada Criação": "rmpv.detalhado.gridHeader.dataAgendadaCriacao",
    "Blindado": "rmpv.detalhado.gridHeader.blindado",
  }

  constructor(private service: RmpvDetalhadoService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: RmpvDetalhadoFiltroService,
    private detalhado: FiltroService,
    private currency: CurrencyPipe,
    private exportExcelService: ExportExcelService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private date: DatePipe,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) {
    this.filtros = {};
    this.nomeModulo = 'detalhado';
    this.filtrosMarcas = new FiltroMarcas(this.servico);
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.filtrosTipoOs = new FiltroTipoOs(this.servico);

    this.form = this.fb.group({
      data_inicial: [''],
      data_final: [''],
      marcas: [''],
      dealer: [''],
      regiao: [''],
      mercado: [''],
      grupo_economico: [''],
      chassi: [''],
      placa: [''],
      numero: [''],
      nome_cliente: [''],
      documento_cliente: [''],
      part_number: [''],
      modelo_veic: [''],
      status: [''],
      entregue: [''],
      blindado: [''],
      dealers: [''],
      tipo_os: [''],
      andamento: [[]],
      paginaAtual: this.first + 1,
      quantidadeRegistrosPorPagina: this.rows
    });
  }

  ngOnInit() {
    const dataInicio = new Date();
    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);
    this.dataInicial = firstDay;
    const today = new Date();
    this.dataFinal = today;
   this.carregarFiltrosUrl();

    this.checarChassi();
    // this.cargaTela = true;

    this.changeLanguageValue();
    this.preencherGruposEconomicos();
    this.preencherStatus();
    this.preencherEntregue();
    this.preencherBlindado();
    this.columnsGeral = [
      { field: 'detalhe', header: '', width: '50px' },
      { field: 'codDealer', header: 'rmpv.detalhado.gridHeader.codDealer', width: '130px', alignment: 'text-center' },
      { field: 'nomeDealer', header: 'rmpv.detalhado.gridHeader.nomeDealer', width: '300px', alignment: 'text-center' },
      { field: 'numero', header: 'rmpv.detalhado.gridHeader.os', width: '80px', alignment: 'text-center' },
      { field: 'idNumeroOs', header: 'rmpv.detalhado.gridHeader.idNumeroOs', width: '180px', alignment: 'text-center' },
      { field: 'cliente', header: 'rmpv.detalhado.gridHeader.cliente', width: '350px', alignment: 'text-center' },
      { field: 'modelo', header: 'rmpv.detalhado.gridHeader.modelo', width: '200px', alignment: 'text-center' },
      { field: 'chassi', header: 'rmpv.detalhado.gridHeader.chassi', width: '153px', alignment: 'text-center' },
      { field: 'blindado', header: 'rmpv.detalhado.gridHeader.blindado', type: { transform: this.formatarBlindado }, width: '150px', alignment: 'text-center' },
      { field: 'valorServico', header: 'rmpv.detalhado.gridHeader.valorServico', type: { transform: this.formatarMoeda }, width: '150px', alignment: 'text-center' },
      { field: 'horasVendidas', header: 'rmpv.detalhado.gridHeader.horasVendidas', width: '150px', alignment: 'text-center' },
      { field: 'valorPeca', header: 'rmpv.detalhado.gridHeader.valorPeca', type: { transform: this.formatarMoeda }, width: '150px', alignment: 'text-center' },
      { field: 'valorDevolucao', header: 'rmpv.detalhado.gridHeader.devolucao', type: { transform: this.formatarMoeda }, width: '150px', alignment: 'text-center' },
      { field: 'faturamento', header: 'rmpv.detalhado.gridHeader.faturamento', type: { transform: this.formatarMoeda }, width: '150px', alignment: 'text-center' },
      { field: 'dataAgendadaCriacao', header: 'rmpv.detalhado.gridHeader.dataAgendadaCriacao', width: '250px', alignment: 'text-center' },
      { field: 'dataEmissao', header: 'rmpv.detalhado.gridHeader.dataEmissao', width: '150px', alignment: 'text-center' },
      { field: 'status', header: 'rmpv.detalhado.gridHeader.status', width: '100px', alignment: 'text-center' },
      { field: 'recepcionista', header: 'rmpv.detalhado.gridHeader.recepcionista', width: '250px', alignment: 'text-center' },
      { field: 'consultor', header: 'rmpv.detalhado.gridHeader.consultor', width: '250px', alignment: 'text-center' },
      { field: 'dataEntregue', header: 'rmpv.detalhado.gridHeader.dataEntrega', width: '150px', alignment: 'text-center' },
      { field: 'tipo', header: 'rmpv.detalhado.gridHeader.tipoOS', width: '150px', alignment: 'text-center' },
      { field: 'tipoDealerOs', header: 'rmpv.detalhado.gridHeader.tipoDealerOs', width: '150px', alignment: 'text-center' },
      { field: 'liberacao', header: 'rmpv.detalhado.gridHeader.dataLiberacao', width: '180px', alignment: 'text-center' },
      { field: 'encerramento', header: 'rmpv.detalhado.gridHeader.dataEncerramento', width: '180px', alignment: 'text-center' },
      { field: 'kmAtual', header: 'rmpv.detalhado.gridHeader.kmAtual', width: '150px', alignment: 'text-center' },
      { field: 'complemento', header: 'rmpv.detalhado.gridHeader.complemento', width: '180px', alignment: 'text-center' },
      { field: 'dataFimServico', header: 'rmpv.detalhado.gridHeader.dataFimServico', width: '250px', alignment: 'text-center' },
      { field: 'andamento', header: 'rmpv.detalhado.gridHeader.andamento', width: '200px', alignment: 'text-center' },
      { field: 'tipoServico', header: 'rmpv.detalhado.gridHeader.tipoServico', width: '180px', alignment: 'text-center' },
      { field: 'numero_nf_peca', header: 'rmpv.detalhado.gridHeader.numeroNfPeca', width: '180px', alignment: 'text-center' },
      { field: 'serie_nf_peca', header: 'rmpv.detalhado.gridHeader.serieNfPeca', width: '150px', alignment: 'text-center' },
      { field: 'data_nf_peca', header: 'rmpv.detalhado.gridHeader.dataNfPeca', width: '150px', alignment: 'text-center' },
      { field: 'numero_nf_mao_obra', header: 'rmpv.detalhado.gridHeader.numeroNfMaoObra', width: '200px', alignment: 'text-center' },
      { field: 'serie_nf_mao_obra', header: 'rmpv.detalhado.gridHeader.serieNfMaoObra', width: '180px', alignment: 'text-center' },
      { field: 'data_nf_mao_obra', header: 'rmpv.detalhado.gridHeader.dataNfMaoObra', width: '180px', alignment: 'text-center' },
      { field: 'numero_prefeitura', header: 'rmpv.detalhado.gridHeader.numeroPrefeitura', width: '180px', alignment: 'text-center' },
    ];

    this.columnsResumida = [
      { field: 'detalhe', header: '', width: '30px' },
      { field: 'codDealer', header: 'rmpv.detalhado.gridHeader.codDealer', width: '70px' },
      { field: 'nomeDealer', header: 'rmpv.detalhado.gridHeader.nomeDealer', width: '140px' },
      { field: 'numeroOS', header: 'rmpv.detalhado.gridHeader.os', width: '60px' },
      { field: 'status', header: 'rmpv.detalhado.gridHeader.status', width: '100px', alignment: 'text-center' },
      { field: 'chassi', header: 'rmpv.detalhado.gridHeader.chassi', width: '143px' },
      { field: 'dataAbertura', header: 'rmpv.detalhado.gridHeader.dataEmissao', width: '104px', alignment: 'text-center' }
    ];

    this._selectedColumns = this.columns;

    this.filtrosMarcas.carregar();
    this.filtrosTipoOs.carregar();
    this.filtrosDealers.carregar();
    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));
    this.recebeFiltro();
  }

  ngOnDestroy(): void {
    if (this.listagemSub) {
      this.listagemSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.resetarDados();
  }

  private resetarDados(): void {
    this.registros = [];
    this.totalRecords = 0;
    this.first = 0;
    this.totais = {};
    this.animatedValues = {
      valor_servico: 0,
      valor_peca: 0,
      valor_devolucao: 0,
      faturamento: 0
    };
    this.loading = false;
    this.cargaTela = false;
    this.filtrado = false;
    this.idOs = null;
    this.temAcompanhamentoOs = false;
    this.f.paginaAtual.setValue(1);
    this.f.quantidadeRegistrosPorPagina.setValue(this.rows);
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.columns.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  /** Dados da página atual para exibição (paginação client-side). */
  get registrosExibidos(): any[] {
    if (!this.registros || this.registros.length === 0) { return []; }
    return this.registros.slice(this.first, this.first + this.rows);
  }

  onCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.buscaResumida = checked;
  }


  private getAll(parameter?: any, fromResumidaDetail?: boolean, fromFilter?: boolean) {
    this.columns = [...this.columnsGeral];
    this.cdRef.detectChanges();
    if (fromResumidaDetail && parameter) {
      this.dataInicio = this.date.transform(new Date(2012, 0, 1), 'dd-MM-yyyy');
      this.dataFim = this.date.transform(new Date(), 'dd-MM-yyyy');
      this.idDealer = parameter.idDealer ?? parameter.codDealer;
      this.chassi = parameter.chassi ?? '';
      this.numeroOS = parameter.numeroOS ?? parameter.numero ?? '';
      this.paginaAtual = 1;
      this.quantidadeRegistrosPorPagina = 10;
    } else if (this.buscaResumida == true) {
      const dataFormatada = this.formatarData(parameter.dataAbertura);
      this.dataInicio = dataFormatada;
      this.dataFim = dataFormatada;
      this.idDealer = parameter.idDealer;
      this.chassi = parameter.chassi;
      this.numeroOS = parameter.numeroOS;
      this.paginaAtual = 1;
      this.quantidadeRegistrosPorPagina = 10
    } else if (this.buscaResumida == false || this.buscaResumida == undefined) {
      this.dataInicio = this.f.data_inicial.value;
      this.dataFim = this.f.data_final.value;
      this.idDealer = this.f.dealer.value;
      this.chassi = this.f.chassi.value;
      this.numeroOS = this.f.numero.value;
      this.paginaAtual = this.f.paginaAtual.value;
      this.quantidadeRegistrosPorPagina = this.f.quantidadeRegistrosPorPagina.value;
    }
    this.detalheGrid = false;
    this.cargaTela = true;
    this.loading = true;

    if (this.listagemSub) {
      this.listagemSub.unsubscribe();
    }
    this.listagemSub = this.service.getDados(this.f.marcas.value, this.dataInicio, this.dataFim, this.idDealer, this.f.regiao.value,
      this.f.mercado.value, this.f.grupo_economico.value, this.chassi, this.f.placa.value, this.numeroOS,
      this.f.nome_cliente.value, this.f.documento_cliente.value, this.f.status.value, this.f.entregue.value, this.f.blindado.value, this.f.part_number.value, this.f.dealers.value, this.f.tipo_os.value, this.f.modelo_veic.value, this.getAndamentoFiltroParam()).subscribe(res => {
        const dados = res.dados || [];
        this.atualizarAndamentosDisponiveis(res.andamentos);

        if (!dados || dados.length === 0) {
          if (fromFilter) {
            this.messageService.add({ key: 'rmpvDetalhado', severity: 'error', summary: 'Aviso', detail: 'Não foi encontrado resultados para esse filtro.', life: 5000 });
          }
          this.registros = [];
          this.totalRecords = 0;
          this.first = 0;
          this.totais = {};
          this.animatedValues = {
            valor_servico: 0,
            valor_peca: 0,
            valor_devolucao: 0,
            faturamento: 0
          };
          this.loading = false;
          this.cargaTela = false;
          this.cdRef.detectChanges();
          return;
        }

        this.totalRecords = res.total_registros != null ? res.total_registros : dados.length;
        this.registros = dados;
        this.first = 0;
        this.f.paginaAtual.setValue(1);
        this.f.quantidadeRegistrosPorPagina.setValue(this.rows);
        if (this.paginator) {
          this.paginator.changePage(0);
        }
        this.cargaTela = false;

        this.totais.valor_servico = this.conversaoLibraConverte.conversaoLibra(res.valorServico || 0, null, null);
        this.totais.faturamento = this.conversaoLibraConverte.conversaoLibra(res.faturamento || 0, null, null);
        this.totais.valor_peca = this.conversaoLibraConverte.conversaoLibra(res.valorPeca || 0, null, null);
        this.totais.valor_devolucao = this.conversaoLibraConverte.conversaoLibra(res.valorDevolucao || 0, null, null);
        this.totais.quantidade = this.conversaoLibraConverte.conversaoLibra(res.quantidade, null, null);
        this.totais.horas_vendidas = res.horasVendidas || 0;

        // Inicia animações dos valores
        setTimeout(() => {
          this.animateValue('valor_servico', this.totais.valor_servico, 1000);
          this.animateValue('valor_peca', this.totais.valor_peca, 1000);
          this.animateValue('valor_devolucao', this.totais.valor_devolucao, 1000);
          this.animateValue('faturamento', this.totais.faturamento, 1000);
        }, 100);

        for (const dados of res?.dados) {
          dados.valorServico = this.conversaoLibraConverte.conversaoLibra(dados.valorServico, null, null);
          dados.valorPeca = this.conversaoLibraConverte.conversaoLibra(dados.valorPeca, null, null);
          dados.valorDevolucao = this.conversaoLibraConverte.conversaoLibra(dados.valorDevolucao, null, null);
          dados.faturamento = this.conversaoLibraConverte.conversaoLibra(dados.faturamento, null, null);
          if (dados.horasVendidas === null || dados.horasVendidas === undefined || isNaN(dados.horasVendidas)) {
            dados.horasVendidas = 0;
          }
        }

        this.registros.forEach(dados => {
          dados.cliente = dados.cliente?.nome ?? dados.cliente;
          dados.modelo = dados.veiculo?.modelo ?? dados.modelo;
          dados.chassi = dados.veiculo?.chassi ?? dados.chassi;
          dados.blindado = dados.blindado ?? dados.veiculo?.blindado;
          dados.tipo = dados.tipo?.tipo ?? dados.tipo;
          dados.dataEntregue = this.validarData(dados.dataEntregue);
          dados.dataEmissao = this.validarData(dados.dataEmissao);
          dados.dataFimServico = this.validarData(dados.dataFimServico);
          dados.liberacao = this.validarData(dados.liberacao);
          dados.encerramento = this.validarData(dados.encerramento);
          dados.data_nf_peca = this.validarData(dados.data_nf_peca);
          dados.dataAgendadaCriacao = this.validarData(dados.dataAgendadaCriacao);
          dados.data_nf_mao_obra = this.validarData(dados.data_nf_mao_obra);
          Utils.sanitizarRegistro(dados);
          this.loading = false;
          this.cargaTela = false;
        });
        const temIdNumeroOsDiferente = this.registros?.some(dados => {
          const numeroOs = dados?.numero ?? dados?.numeroOS;
          if (numeroOs == null || dados?.idNumeroOs == null) {
            return false;
          }
          return numeroOs.toString() !== dados.idNumeroOs.toString();
        });

        if (temIdNumeroOsDiferente) {
          this.columns = [...this.columnsGeral];
        } else {
          this.columns = this.columnsGeral.filter(col => col.field !== 'idNumeroOs');
        }
        this._selectedColumns = this.columns;
        this.cdRef.detectChanges();
      });
  }

  private getAllBuscaResumida() {
    this.columns = [...this.columnsResumida];
    this.cdRef.detectChanges();
    this.cargaTela = true;
    this.loading = true;
    this.detalheGrid = true;
    if (this.listagemSub) {
      this.listagemSub.unsubscribe();
    }
    this.listagemSub = this.service.getGenerico('/rmpv/detalhado/busca/resumida', {
      chassi: this.f.chassi.value,
      page: this.f.paginaAtual.value ? this.f.paginaAtual.value : 1,
      size: this.f.quantidadeRegistrosPorPagina.value ? this.f.quantidadeRegistrosPorPagina.value : 10
    }).subscribe({
      next: response => {
        let novosRegistros = response || [];
        if (typeof response === 'string' && response.trim() === '') {
            novosRegistros = [];
        }

        if (!novosRegistros || novosRegistros.length === 0) {
          this.messageService.add({ key: 'rmpvDetalhado', severity: 'info', summary: 'Aviso', detail: 'Nenhuma passagem encontrada para o chassi informado.', life: 5000 });
          this.displayFiltros = false;
          this.loading = false;
          this.cargaTela = false;
          this.cdRef.detectChanges();
          return;
        }

        this.columns = [...this.columnsResumida];
        novosRegistros.forEach(r => Utils.sanitizarRegistro(r));
        this.registros = novosRegistros;

        this.totalRecords = novosRegistros[0]?.totalRegistros || 0;
        this.displayFiltros = false;
        this.loading = false;
        this.cargaTela = false;
        this.cdRef.detectChanges();
      },
      error: error => {
        const mensagemErro = error?.error?.message || (typeof error?.error === 'string' ? error.error : 'Ocorreu um erro ao buscar os dados resumidos. Verifique o chassi informado.');
        this.messageService.add({ key: 'rmpvDetalhado', severity: 'warn', summary: 'Aviso', detail: mensagemErro, life: 10000 });
        this.registros = [];
        this.loading = false;
        this.cargaTela = false;
      }
    });
  }

  protected filtroAPI() {
    this.columns = [...[]];
    if (this.buscaResumida == true) {
      this.f.paginaAtual.setValue(1);
      if (this.paginator) {
        this.paginator.changePage(0);
      }
      this.countFaturamentoServicPeca = true;
      this.getAllBuscaResumida();
    } else if (this.buscaResumida == false || this.buscaResumida == undefined) {
      this.displayFiltros = false;
      this.filtrado = true;
      this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
      this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));
      this.filtrosSelecionados();
      this.f.paginaAtual.setValue(1);
      this.f.quantidadeRegistrosPorPagina.setValue(10);
      this.countFaturamentoServicPeca = false;
      this.getAll(undefined, undefined, true);
    }
  }

  private filtrosSelecionados() {
    const marcas = [];
    const tipoOs = [];
    const dealers = [];

    this.incluirFiltroMarcas(marcas);
    this.incluirFiltroTiposOs(tipoOs);
    this.incluirFiltroDealers(dealers);

    this.filtros.marcas = marcas.map(r => r.valor);
    this.filtros.tipoOs = tipoOs.map(r => r.valor);
    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.marcas.length != 0) {
      this.f.marcas.setValue(this.filtros.marcas[0]);
    } else {
      this.f.marcas.setValue('');
    }

    if (this.filtros.tipoOs.length != 0) {
      this.f.tipo_os.setValue(this.filtros.tipoOs[0]);
    } else {
      this.f.tipo_os.setValue('');
    }

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.dataEntrega
      || this.f.grupo_economico.value
      || this.f.chassi.value
      || this.f.placa.value
      || this.f.numero.value
      || this.f.nome_cliente.value
      || this.f.documento_cliente.value
      || this.f.status.value
      || this.f.entregue.value
      || this.f.blindado.value !== ''
      || (this.f.andamento.value && this.f.andamento.value.length > 0)
      || this.f.part_number.value
      || this.f.modelo_veic.value;
  }

  private getAndamentoFiltroParam(): string {
    const selecionados = this.f.andamento?.value;
    if (!selecionados || !Array.isArray(selecionados) || selecionados.length === 0) {
      return '';
    }
    return selecionados
      .filter((v: string) => v != null && String(v).trim() !== '')
      .join(',');
  }

  private atualizarAndamentosDisponiveis(andamentos: string[]): void {
    this.andamentosOpcoes = (andamentos || []).map((a: string) => ({ label: a, value: a }));
    const selecionados = this.f.andamento?.value as string[];
    if (Array.isArray(selecionados) && selecionados.length > 0) {
      const validos = selecionados.filter(s =>
        this.andamentosOpcoes.some(o => o.value === s)
      );
      if (validos.length !== selecionados.length) {
        this.f.andamento.setValue(validos);
      }
    }
  }

  private preencherGruposEconomicos() {
    this.detalhado.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private preencherStatus() {
    this.status = [
      { nome: 'rmpv.detalhado.filtros.statusValores.aberta', valor: 0 },
      { nome: 'rmpv.detalhado.filtros.statusValores.fechada', valor: 1 },
      { nome: 'rmpv.detalhado.filtros.statusValores.cancelada', valor: 2 },
    ];
  }

  private preencherEntregue() {
    this.entregue = [
      { nome: 'rmpv.detalhado.filtros.entregueValores.sim', valor: 0 },
      { nome: 'rmpv.detalhado.filtros.entregueValores.nao', valor: 1 },
    ];
  }

  private preencherBlindado() {
    this.blindado = [
      { nome: 'rmpv.detalhado.filtros.blindadoValores.sim', valor: true },
      { nome: 'rmpv.detalhado.filtros.blindadoValores.nao', valor: false },
    ];
  }

  protected selecionarMarcas() {
    this.displayFiltrosMarcas = true;
  }

  protected removerMarca(marca: any) {
    marca.selecionado = false;
    const index = this.filtros.marcas;
    if (index > -1) {
      this.filtros.marcas.splice(index, marca);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarMarcaFiltro(marca: any) {
    marca.selecionado = true;
    const sel = [];

    this.incluirFiltroMarcas(sel);
    this.filtros.marcas = sel;
  }

  protected selecionarTipoOs() {
    this.displayFiltrosOS = true;
  }

  protected removerTipoOs(tipo: any) {
    tipo.selecionado = false;
    const index = this.filtros.tipoOs;
    if (index > -1) {
      this.filtros.tipoOs.splice(index, tipo);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarTipoOsFiltro(tipo: any) {
    tipo.selecionado = true;
    const sel = [];

    this.incluirFiltroTiposOs(sel);
    this.filtros.tipoOs = sel;
  }

  protected selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  protected removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  protected exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private incluirFiltroMarcas(filtros: any[]) {
    if (this.filtrosMarcas.selecionados().length > 0) {
      const item = { 'chave': 'marcas', 'valor': [] };
      this.filtrosMarcas.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private incluirFiltroTiposOs(filtros: any[]) {
    if (this.filtrosTipoOs.selecionados().length > 0) {
      const item = { 'chave': 'tipos', 'valor': [] };
      this.filtrosTipoOs.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.dataEntrega = '';
    this.f.grupo_economico.setValue('');
    this.f.chassi.setValue('');
    this.f.placa.setValue('');
    this.f.numero.setValue('');
    this.f.nome_cliente.setValue('');
    this.f.documento_cliente.setValue('');
    this.f.status.setValue('');
    this.f.entregue.setValue('');
    this.f.blindado.setValue('');
    this.f.andamento.setValue([]);
    this.f.part_number.setValue('');
    this.f.modelo_veic.setValue('');
    this.buscaResumida = false;
  }

  public limpaDataInicial(dataInicial) {
    const hoje = new Date();
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.dataInicial = primeiroDia;    
  }

  public limpaDataFinal(dataFinal) {
    const hoje = new Date();
    this.dataFinal = hoje;
  }

  protected getTranslate(value) {
    if (value.status == 'FECHADA' || value.status == 1) {
      // return value.status = 'rmpv.detalhado.gridValores.status.fechada';
      return this.translate.currentLang == "br" ? value.status = "FECHADA" : value.status = "CLOSED";
    }
    if (value.status == 'CANCELADA' || value.status == 2) {
      // return value.status = 'rmpv.detalhado.gridValores.status.cancelada';
      this.translate.currentLang == "br" ? value.status = "CANCELADA" : value.status = "CANCELED";
    }
    if (value.status === 'ABERTA' || value.status == 0) {
      // return value.status = 'rmpv.detalhado.gridValores.status.aberta';
      this.translate.currentLang == "br" ? value.status = "ABERTA" : value.status = "OPEN";
    }
    return this.dadosTranslate[value];
  }

  public visualizar(registros) {
    if (this.detalheGrid == true) {
      this.buscaAnalitica = true;
      this.buscaResumida = false;
      this.countFaturamentoServicPeca = false;
      this.getAll(registros, true);
    } else {
      this.buscaAnalitica = false;
      const retorno: RetornoSelecao = new RetornoSelecao();
      retorno.novoCadastro = false;
      retorno.registro = registros.id;
      this.idOs = retorno.registro;
      this.temAcompanhamentoOs = !!registros.temAcompanhamento;
      this.service.ver(retorno);
    }
  }

  public voltar() {
    this.idOs = null;
    this.temAcompanhamentoOs = false;
  }

  public paginate(event) {
    this.first = event.first;
    this.rows = event.rows;
    this.f.quantidadeRegistrosPorPagina.setValue(event.rows);
    this.f.paginaAtual.setValue(event.page + 1);
    this.displayRows = event.first;
    if (this.buscaResumida === true) {
      this.getAllBuscaResumida();
    }
  }

  //export Excel
  exportExcel() {
    if (this.buscaResumida == true) {
      this.exportExcelResumido();
    } else if (this.buscaResumida == false || this.buscaResumida == undefined) {
      this.exportExcelAnalitico();
    }
  }

  public exportExcelAnalitico() {
    let registros = [];

    this.service.getDados(this.f.marcas.value, this.dataInicio, this.dataFim, this.idDealer, this.f.regiao.value,
      this.f.mercado.value, this.f.grupo_economico.value, this.chassi, this.f.placa.value, this.numeroOS,
      this.f.nome_cliente.value, this.f.documento_cliente.value, this.f.status.value, this.f.entregue.value, this.f.blindado.value, this.f.part_number.value, this.f.dealers.value, this.f.tipo_os.value, this.f.modelo_veic.value, this.getAndamentoFiltroParam()).subscribe(res => {

        registros = res.dados || [];

        registros.forEach(dados => {
          dados.cliente = dados.cliente?.nome ?? dados.cliente;
          dados.modelo = dados.veiculo?.modelo ?? dados.modelo;
          dados.chassi = dados.veiculo?.chassi ?? dados.chassi;
          dados.blindado = dados.blindado ?? dados.veiculo?.blindado;
          dados.tipo = dados.tipo?.tipo ?? dados.tipo;
          dados.dataEntregue = this.validarData(dados.dataEntregue);
          dados.dataEmissao = this.validarData(dados.dataEmissao);
          dados.dataFimServico = this.validarData(dados.dataFimServico);
          dados.liberacao = this.validarData(dados.liberacao);
          dados.encerramento = this.validarData(dados.encerramento);
          dados.data_nf_peca = this.validarData(dados.data_nf_peca);
          dados.data_nf_mao_obra = this.validarData(dados.data_nf_mao_obra);
          dados.dataAgendadaCriacao = this.validarData(dados.dataAgendadaCriacao);
          Utils.sanitizarRegistro(dados);
        });

        
        console.log('=== DEBUG EXPORT EXCEL ===');
        console.log('Total registros:', registros.length);
        registros.forEach((r, i) => {
          if (r.numero_prefeitura || r.data_nf_peca !== ' - ' || r.data_nf_mao_obra !== ' - ') {
            console.log(`Registro ${i}:`, {
              chassi: r.chassi,
              data_nf_peca: r.data_nf_peca,
              data_nf_mao_obra: r.data_nf_mao_obra,
              numero_prefeitura: r.numero_prefeitura,
            });
          }
        });

        if (registros.length > 0) {
          this.exportExcelWithCurrencyFormat(registros);
        }
      });

    this.messageService.add({ key: 'rmpvDetalhado', severity: 'info', summary: 'Aviso', detail: 'Aguarde a exportação, pode demorar um pouco...', life: 3000 });
  }

  private exportExcelWithCurrencyFormat(registros: any[]) {
    // Preparar dados para o Excel
    const dadosFormatados = registros.map(r => {
      let linha = {};
      this.columnsGeral.forEach(c => {
          const header = this.translateHeader(c.header);
          if (!header) {
            return; // Pula colunas sem header traduzido (ex: detalhe, idNumeroOs)
          }
          if (c.field === 'status') {
            linha[header] = this.translateField(r[c.field]);
          } else if (c.field === 'blindado') {
            linha[header] = this.formatarBlindado(r[c.field]);
          } else if (c.field === 'numero_prefeitura') {
            linha[header] = r[c.field] != null ? Utils.sanitizarTexto(String(r[c.field])) : '';
          } else {
            linha[header] = Utils.sanitizarTexto(r[c.field] ?? '');
          }
      });
      return linha;
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dadosFormatados);
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const headers = Object.keys(dadosFormatados[0]);
    const currencyHeaders = [
      this.translateHeader('rmpv.detalhado.gridHeader.valorServico'),
      this.translateHeader('rmpv.detalhado.gridHeader.valorPeca'),
      this.translateHeader('rmpv.detalhado.gridHeader.devolucao'),
      this.translateHeader('rmpv.detalhado.gridHeader.faturamento')
    ];
    
    const currencyColumnIndexes = currencyHeaders.map(header => headers.indexOf(header)).filter(index => index !== -1);

    for (let row = range.s.r + 1; row <= range.e.r; row++) {
      currencyColumnIndexes.forEach(colIndex => {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].z = '#,##0.00';
        }
      });
    }

    
    const prefeituraHeader = this.translateHeader('rmpv.detalhado.gridHeader.numeroPrefeitura');
    const prefeituraColIndex = headers.indexOf(prefeituraHeader);
    if (prefeituraColIndex !== -1) {
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: prefeituraColIndex });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].t = 's';
          worksheet[cellAddress].v = String(worksheet[cellAddress].v ?? '');
        }
      }
    }

    // Definir larguras das colunas
    const columnWidths = headers.map(() => ({ wch: 15 }));
    worksheet['!cols'] = columnWidths;

    // Criar workbook e salvar
    const workbook: XLSX.WorkBook = { 
      Sheets: { 'RMPV Detalhado': worksheet }, 
      SheetNames: ['RMPV Detalhado'] 
    };
    
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    // Download do arquivo
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = `rmpv_detalhado.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  exportExcelResumido() {
    this.service.getGenerico('/rmpv/detalhado/busca/resumida', {
      chassi: this.f.chassi.value,
      page: this.f.paginaAtual.value ? this.f.paginaAtual.value : 1,
      size: this.f.quantidadeRegistrosPorPagina.value ? this.f.quantidadeRegistrosPorPagina.value : 10
    }).subscribe({
      next: response => {
        if (response.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.ExportTOExcelJSON(response.map(r => {
            let linha = {};
            this.columnsResumida.forEach(c => {
              if (c.field !== 'detalhe') {
                const header = this.translateHeaderResumido(c.header);
                if (header) {
                  linha[header] = c.field === 'status' ? this.translateField(r[c.field]) : Utils.sanitizarTexto(r[c.field] ?? '');
                }
              }
            });
            return linha;
          }));
        }
      },
      error: error => {
        console.error('Erro na requisição:', error);
      }
    });

    this.messageService.add({ key: 'rmpvDetalhado', severity: 'info', summary: 'Aviso', detail: 'Aguarde a exportação, pode demorar um pouco...', life: 3000 });
  }

  public translateHeader(item) {
    if (item == "rmpv.detalhado.gridHeader.recepcionista") {
      return this.translate.currentLang == "br" ? "Recepcionista" : "Receptionist";
    }
    if (item == "rmpv.detalhado.gridHeader.consultor") {
      return this.translate.currentLang == "br" ? "Consultor" : "Service Advisor";
    }
    if (item == "rmpv.detalhado.gridHeader.os") {
      return this.translate.currentLang == "br" ? "O.S." : "S.O.";
    }
    if (item == "rmpv.detalhado.gridHeader.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }
    if (item == "rmpv.detalhado.gridHeader.nomeDealer") {
      return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    }
    if (item == "rmpv.detalhado.gridHeader.dataEmissao") {
      return this.translate.currentLang == "br" ? "Data Emissão" : "Issuance Date";
    }
    if (item == "rmpv.detalhado.gridHeader.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "rmpv.detalhado.gridHeader.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "rmpv.detalhado.gridHeader.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "rmpv.detalhado.gridHeader.blindado") {
      return this.translate.currentLang == "br" ? "Blindado" : "Armored";
    }
    if (item == "rmpv.detalhado.gridHeader.valorServico") {
      return this.translate.currentLang == "br" ? "Valor Serviço" : "Service Value";
    }
    if (item == "rmpv.detalhado.gridHeader.valorPeca") {
      return this.translate.currentLang == "br" ? "Valor Peça" : "Part Value";
    }
    if (item == "rmpv.detalhado.gridHeader.horasVendidas") {
      return this.translate.currentLang == "br" ? "Horas Vendidas" : "Hours Sold";
    }
    if (item == "rmpv.detalhado.gridHeader.devolucao") {
      return this.translate.currentLang == "br" ? "Devolução" : "Devolution";
    }
    if (item == "rmpv.detalhado.gridHeader.faturamento") {
      return this.translate.currentLang == "br" ? "Faturamento" : "Revenues";
    }
    if (item == "rmpv.detalhado.gridHeader.status") {
      return "Status"
    }
    if (item == "rmpv.detalhado.gridHeader.dataEntrega") {
      return this.translate.currentLang == "br" ? "Data Entrega" : "Delivery Date";
    }
    if (item == "rmpv.detalhado.gridHeader.tipoOS") {
      return this.translate.currentLang == "br" ? "Tipo O.S." : "S.O. Type";
    }
    if (item == "rmpv.detalhado.gridHeader.tipoDealerOs") {
      return this.translate.currentLang == "br" ? "Tipo Dealer O.S." : "Dealer S.O. Type";
    }
    if (item == "rmpv.detalhado.gridHeader.dataFimServico") {
      return this.translate.currentLang == "br" ? "Data de Último Apontamento" : "Date of Last Appointment";
    }
    if (item == "rmpv.detalhado.gridHeader.andamento") {
      return this.translate.currentLang == "br" ? "Andamento" : "Progress";
    }
    if (item == "rmpv.detalhado.gridHeader.kmAtual") {
      return this.translate.currentLang == "br" ? "KM Atual" : "Current KM";
    }
    if (item == "rmpv.detalhado.gridHeader.dataEncerramento") {
      return this.translate.currentLang == "br" ? "Data de Fechamento" : "Closing Date";
    }
    if (item == "rmpv.detalhado.gridHeader.dataLiberacao") {
      return this.translate.currentLang == "br" ? "Data de Liberação" : "Release Date";
    }
    if (item == "rmpv.detalhado.gridHeader.complemento") {
      return this.translate.currentLang == "br" ? "Os Complementar" : "Complementary";
    }
    if (item == "rmpv.detalhado.gridHeader.tipoServico") {
      return this.translate.currentLang == "br" ? "Classificação Serviço" : "Service Classification";
    }
    if (item == "rmpv.detalhado.gridHeader.numeroNfPeca") {
      return this.translate.currentLang == "br" ? "Número NF Peça" : "Part Invoice Number";
    }
    if (item == "rmpv.detalhado.gridHeader.serieNfPeca") {
      return this.translate.currentLang == "br" ? "Série NF Peça" : "Part Invoice Series";
    }
    if (item == "rmpv.detalhado.gridHeader.dataNfPeca") {
      return this.translate.currentLang == "br" ? "Data NF Peça" : "Part Invoice Date";
    }
    if (item == "rmpv.detalhado.gridHeader.numeroNfMaoObra") {
      return this.translate.currentLang == "br" ? "Número NF Mão de Obra" : "Labour Invoice Number";
    }
    if (item == "rmpv.detalhado.gridHeader.serieNfMaoObra") {
      return this.translate.currentLang == "br" ? "Série NF Mão de Obra" : "Labour Invoice Series";
    }
    if (item == "rmpv.detalhado.gridHeader.dataNfMaoObra") {
      return this.translate.currentLang == "br" ? "Data NF Mão de Obra" : "Labour Invoice Date";
    }
    if (item == "rmpv.detalhado.gridHeader.numeroPrefeitura") {
      return this.translate.currentLang == "br" ? "Número Prefeitura" : "City Hall Number";
    }
    if (item == "rmpv.detalhado.gridHeader.dataAgendadaCriacao") {
      return this.translate.currentLang == "br" ? "Data Agendada Criação" : "Scheduled Creation Date";
    }
  }

  protected translateHeaderResumido(item) {
    if (item == "rmpv.detalhado.gridHeader.codDealer") {
      return this.translate.currentLang == "br" ? "Cód. Dealer" : "Dealer Code";
    }

    if (item == "rmpv.detalhado.gridHeader.nomeDealer") {
      return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    }

    if (item == "rmpv.detalhado.gridHeader.os") {
      return this.translate.currentLang == "br" ? "O.S." : "S.O.";
    }
    if (item == "rmpv.detalhado.gridHeader.status") {
      return "Status"
    }
    if (item == "rmpv.detalhado.gridHeader.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }

    if (item == "rmpv.detalhado.gridHeader.dataEmissao") {
      return this.translate.currentLang == "br" ? "Data Emissão" : "Issuance Date";
    }
  }

  protected translateField(item) {
    if (item == "rmpv.detalhado.gridValores.status.fechada" || item == "FECHADA" || item == 1) {
      return this.translate.currentLang == "br" ? "FECHADA" : "CLOSED";
    }
    if (item == "rmpv.detalhado.gridValores.status.cancelada" || item == "CANCELADA" || item == 2) {
      return this.translate.currentLang == "br" ? "CANCELADA" : "CANCELED";
    }
    if (item == "rmpv.detalhado.gridValores.status.aberta" || item == "ABERTA" || item == 0) {
      return this.translate.currentLang == "br" ? "ABERTA" : "OPEN";
    }

    return item;
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        if (this.filtrado == true) {
          this.getAll();
        }
      });
  }

  validarData(date: any): any {
    if (date != null && date != undefined) {
      let dateStr = String(date);
      dateStr = dateStr.replace(/\[.*\]$/, '');
      dateStr = dateStr.substr(0, 10);
      const parsed = moment(dateStr);
      if (parsed.isValid()) {
        return parsed.format("DD/MM/YYYY");
      }
      return " - ";
    } else {
      return " - ";
    }
  }

  formatarData(data: string): string {
    return this.date.transform(data, 'dd-MM-yyyy') || '';
  }

  checarChassi() {
    this.form.get('chassi')?.valueChanges.subscribe(value => {
      if (!value) {
        this.buscaResumida = false;
      }
    });
  }

  recebeFiltro() {
    this.service.valorModal$.subscribe(componente => {
      if (componente != null) {
        this.chassiRecebe = componente.chassi;
        if (typeof componente.dataInicial === 'string') {
          const parsedInicial = moment(componente.dataInicial, 'DD/MM/YYYY');
          this.dataInicial = parsedInicial.isValid() ? parsedInicial.toDate() : this.dataInicial;
        } else {
          this.dataInicial = componente.dataInicial;
        }
        if (typeof componente.dataFinal === 'string') {
          const parsedFinal = moment(componente.dataFinal, 'DD/MM/YYYY');
          this.dataFinal = parsedFinal.isValid() ? parsedFinal.toDate() : this.dataFinal;
        } else {
          this.dataFinal = componente.dataFinal;
        }
        this.f.chassi.setValue(this.chassiRecebe);
        this.filtroAPI();
      }
    });
  }

  formatDateTime(value: any): string {
    let pad: Function = (val: number) => {
      return val < 10 ? '0' + val : val;
    };
    return value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate())
      + 'T' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
  }

  // Função para formatação monetária customizada
  formatarMoeda = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '') {
      return 'R$ 0,00';
    }
    return this.currency.transform(valor, 'BRL', 'symbol', '1.2-2', 'pt-BR');
  }

  formatarBlindado = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '') {
      return ' - ';
    }
    const positivo = valor === true || valor === 1 || ['true', 's', 'sim', 'y', 'yes', '1'].includes(String(valor).trim().toLowerCase());
    return this.translate.instant(positivo
      ? 'rmpv.detalhado.filtros.blindadoValores.sim'
      : 'rmpv.detalhado.filtros.blindadoValores.nao');
  }

  formatarNumero = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '') {
      return '0,00';
    }
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor);
  }

  // Função para formatação brasileira dos valores dos cards
  formatarValorBrasileiro = (valor: any): string => {
    if (valor === null || valor === undefined || valor === '' || isNaN(valor)) {
      return '0,00';
    }
    
    // Converte para string para verificar se tem ponto decimal
    let valorStr = valor.toString();
    
    // Se tem ponto decimal, substitui por vírgula e formata
    if (valorStr.includes('.')) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(valorStr));
    } else {
      // Se é número inteiro, formata como tal
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseInt(valorStr));
    }
  }

  // Propriedades para animação dos valores
  animatedValues = {
    valor_servico: 0,
    valor_peca: 0,
    valor_devolucao: 0,
    faturamento: 0
  };

  // Função para animar valores
  animateValue(property: string, targetValue: number, duration: number = 2000) {
    const startValue = 0;
    const startTime = performance.now();
    
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Função de easing para uma animação mais suave
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      
      this.animatedValues[property] = startValue + (targetValue - startValue) * easeOutQuart;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.animatedValues[property] = targetValue;
      }
    };
    
    requestAnimationFrame(animate);
  }

  // Função para obter valor animado formatado
  getAnimatedValue(property: string): string {
    return this.formatarValorBrasileiro(this.animatedValues[property]);
  }
private carregarFiltrosUrl() {
  this.route.queryParams.subscribe(params => {
    const numeroChassi = params['numeroChassi'];
    const dataInicial = params['dataInicial'];
    const dataFinal = params['dataFinal'];

    if (numeroChassi) {
      this.chassi = numeroChassi;
      this.chassiRecebe = numeroChassi;

      if (this.form) {
        this.form.patchValue({
          chassi: numeroChassi
        });
      }
    }

    if (dataInicial) {
      this.dataInicial = new Date(dataInicial + 'T00:00:00');

      if (this.form) {
        this.form.patchValue({
          data_inicial: moment(this.dataInicial).format('DD-MM-YYYY')
        });
      }
    }

    if (dataFinal) {
      this.dataFinal = new Date(dataFinal + 'T00:00:00');

      if (this.form) {
        this.form.patchValue({
          data_final: moment(this.dataFinal).format('DD-MM-YYYY')
        });
      }
    }

    if (numeroChassi || dataInicial || dataFinal) {
      setTimeout(() => {
        this.filtroAPI();
      }, 300);
    }
  });
}
}
